export default function updatePostMedias(state, action) {
  const nextState = { ...state };
  const { mediaKey, newProps } = action.payload;

  nextState[mediaKey] = nextState[mediaKey].map(media => ({ ...media, ...newProps }));

  return nextState;
}
